import { Component, OnChanges, SimpleChanges, inject, input, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { IShopifyProduct } from '@app/_shared/_models';
import { ProductService } from '@app/_shared/_services';
import { ProductCardComponent } from '../product-card/product-card.component';

@Component({
    selector: 'app-similar-products',
    templateUrl: './similar-products.component.html',
    styleUrls: ['./similar-products.component.scss'],
    imports: [ProductCardComponent],
    schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class SimilarProductsComponent implements OnChanges {
  private readonly productService = inject(ProductService);

  readonly productId = input.required<string>();
  public products = new Array<IShopifyProduct>;

  async ngOnChanges(similarChanges: SimpleChanges): Promise<void> {
    if (similarChanges['productId']) {
      this.products = [];
      this.products = await this.productService.loadSimilarProducts(similarChanges['productId'].currentValue);
    }
  }
}
